import {makeAutoObservable} from 'mobx';
import {toast} from 'react-toastify';
import {setCookie, getCookie} from 'lib/utils/cookies';
import {injected, token} from "brandi";
import container from "../../../../lib/ioc"
import {GlobalModelStoreToken, IGlobalStateModel} from "../../../../lib/models/global";

interface ISubmitData {
    email: string
}

interface IUserData {
    email: string,
    code: string
}

type IUpdateClientPersonal =  (userData: string, data: IUserData) => Promise<{status: string}>

export default class AddEmailPopupModel {
    isModalOpen = false;
    isModalEmailOpen = false;
    presaveValues = {};
    email = '';

    constructor(private globalM: IGlobalStateModel) {
        makeAutoObservable(this, {}, {autoBind: true});

        const cookieValue = getCookie('filling_email_popup_shown');
        this.isModalEmailOpen = cookieValue ? JSON.parse(cookieValue) : false;
    }

    setIsModalOpen = (isSetModalOpen: boolean) => {
        this.isModalOpen = isSetModalOpen;
    }

    setIsModalEmailOpen = (isModalEmailOpen: boolean) => {
        this.isModalEmailOpen = isModalEmailOpen;
    }

    setPresaveValues = (presaveValues: ISubmitData) => {
        this.presaveValues = presaveValues;
    }

    setEmail = (email: string) => {
        this.email = email;
    }

    handleEmailSubmit = (data: ISubmitData) => {
        this.setEmail(data.email);
        this.setIsModalOpen(true);
        this.setPresaveValues(data)
    }

    handleUpdate = async (userData: IUserData, updateClientPersonal: IUpdateClientPersonal) => {
        const dataToSend = {...userData};

        if (userData.code) {
            try {
                const result = await updateClientPersonal(this.globalM.get().userId, { ...dataToSend, code: userData.code, email: this.email })

                if (result.status === 'updated') {
                    this.setIsModalOpen(false)
                    this.closeAddEmailPopup()
                    return result
                }
            } catch (error) {
                toast(error?.response?.data?.message, {type: 'error'})
                throw error
            }
        }

        this.setIsModalOpen(true);
    }

    closeAddEmailPopup = () => {
        this.setIsModalEmailOpen(false);
        setCookie('filling_email_popup_shown', false)
    }

    get isFillingEmailPopupShown() {
        const cookieValue = getCookie('filling_email_popup_shown');
        return cookieValue ? JSON.parse(cookieValue) : false;
    }
}

export const AddEmailPopupModelToken = token('AddEmailPopupModel');

container.bind(AddEmailPopupModelToken).toInstance(AddEmailPopupModel).inSingletonScope();

injected(AddEmailPopupModel, GlobalModelStoreToken)